module.exports = __webpack_public_path__ + "media/images/icons/outlined/heart-a3a2219c8355b126d324b2b48c9320c5.svg";